import type { Directive, DirectiveBinding } from 'vue';
import usePermissionStore from '@/store/permission.store';

/**
 * 按钮权限指令
 * 用法: v-permission="'user@create'"
 * 或: v-permission="['user@create', 'user@edit']"
 */
export const permission: Directive = {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    const { value } = binding;

    if (value) {
      const { hasButtonPermission } = usePermissionStore();

      let hasPermission = false;

      if (Array.isArray(value)) {
        // 如果是数组，只要有一个权限即可
        hasPermission = value.some(code => hasButtonPermission(code));
      } else if (typeof value === 'string') {
        // 如果是字符串，检查是否有该权限
        hasPermission = hasButtonPermission(value);
      }

      if (!hasPermission) {
        // 没有权限，移除元素
        el.parentNode?.removeChild(el);
      }
    }
  }
};

/**
 * 注册所有权限指令
 */
export function setupPermissionDirectives(app: any) {
  app.directive('permission', permission);
}
